
import { Component, OnInit, HostListener } from '@angular/core';
import { WindowRef } from '../../utils/window';
import { Router } from '@angular/router';
import { Subject ,  Observable ,  Subscription } from 'rxjs';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { AuthorizationService } from '../authorization/authorization.service';
import { FormGroup, Validators, FormControl, FormBuilder, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TranslateUtil } from '../../utils/translate-util';
import { TranslateService } from '@ngx-translate/core';
import { RecaptchaLoaderService } from '../../utils/recaptchaLoader.service';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service'
import { HeaderComponent } from '../../furniture/header.component';
import { MatDialog } from '@angular/material/dialog';
import { ClassesUtil } from '../../utils/classes-util';
import { CookiesUtil } from '../../utils/cookies-util';
import { AppComponent } from '../../app.component';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';


@Component({
    selector: 'dialog-elements-example-cookiespopup',
    imports: [SharedTranslateModule],
    templateUrl: 'cookiesPopupDialog.component.html'
})
export class CookiesPopupComponent {
  isCanadaPortal = false;
  cookiesUtil: CookiesUtil;
  private _window: WindowRef;
  router: Router;
  contextPath = '';
  currentCountry: string;
  usUrl: string;
  caUrl: string;
  language = '';
  targetRedirect = '';
  localRedirect = '';

  constructor(router: Router, window: WindowRef,
    public translateUtil: TranslateUtil,
    public translate: TranslateService, 
    ) {
    this.router = router;
    this._window = window;
    this.contextPath = (this._window.nativeWindow as any).mbfs.contextPath;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    }

  ngOnInit() {
    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().subscribe(val => {
        this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
        this.currentCountry = val;
    });
    this.langInit();
  }

  langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    if (this.language === 'en-CA') {
      this.localRedirect = this.usUrl + '/ca/en/';
  } else if (this.language === 'fr-CA') {
      this.localRedirect = this.usUrl + '/ca/fr/';
  } else {
      this.localRedirect = this.usUrl;
  }
  }

  enableGA(e: Event, toggle: string) {
    sessionStorage.setItem('enableGA', 'yes');
    localStorage.setItem('enableGA', 'yes');
    if(toggle == "false"){
      sessionStorage.setItem('enableGA', 'no');
      localStorage.setItem('enableGA', 'no');
    }
    let redirect = '';
    this.translate.get('LoginModal.GARedirect').subscribe((data:any)=> {
      redirect= this.usUrl +  data + toggle;
     });
     this._window.nativeWindow.location.href = redirect;
  }
}